/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Roles_CreatedInputs */

const en_admin_roles_created = /** @type {(inputs: Admin_Roles_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Role created`)
};

const zh_admin_roles_created = /** @type {(inputs: Admin_Roles_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`角色已创建`)
};

/**
* | output |
* | --- |
* | "Role created" |
*
* @param {Admin_Roles_CreatedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_roles_created = /** @type {((inputs?: Admin_Roles_CreatedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Roles_CreatedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_roles_created(inputs)
	return zh_admin_roles_created(inputs)
});
export { admin_roles_created as "admin.roles.created" }